//@flow
import React from 'react';
import i18n from 'app/common/lib/i18n';
import Modal from 'app/common/react/ui/Modal';
import { Box, Button, Text } from 'gestalt';

type Props = {|
  onHide: () => void,
  variant: 'changePassword' | 'setPassword' | 'verifyEmailAddress',
|};

export default function CheckEmailModal({ onHide, variant }: Props) {
  const titleText = i18n._('Please check your email');

  let bodyText = '';
  switch (variant) {
    case 'changePassword':
      bodyText = i18n._(
        'We’ll send instructions for changing your password in just a minute.',
        'Body of email for changing password modal',
      );
      break;
    case 'setPassword':
      bodyText = i18n._(
        'We’ll send instructions for setting your password in just a minute.',
        'Body of email for setting password modal',
      );
      break;
    case 'verifyEmailAddress':
      bodyText = i18n._(
        'We’ll send you a verification email in just a minute.',
        'Body of email for verifying email address modal',
      );
      break;
    default:
      break;
  }

  return (
    <Modal
      accessibilityCloseLabel={i18n._('Close')}
      accessibilityModalLabel={titleText}
      onDismiss={onHide}
      heading={titleText}
      size="md"
      footer={
        <Box display="flex" justifyContent="end">
          <Button color="red" inline onClick={onHide} text={i18n._('Okay')} size="md" />
        </Box>
      }
    >
      <Box padding={4}>
        <Text>{bodyText}</Text>
      </Box>
    </Modal>
  );
}
